<div class="card shadow-sm">
  <div class="project-edit-header">
    <a routerLink="/projects" class="btn btn-outline btn-with-icon back-link">
      <mat-icon aria-hidden="true">arrow_back</mat-icon>
      Retour à la liste
    </a>
    @if (isAdmin() && canArchiveCurrentProject()) {
    <button class="btn btn-warning btn-with-icon btn-archive" (click)="archiveProject()">
      <mat-icon aria-hidden="true">inventory_2</mat-icon>
      Archiver le projet
    </button>
    }
    @if (isAdmin() && canUnarchiveCurrentProject()) {
    <button class="btn btn-primary btn-with-icon btn-unarchive" (click)="unarchiveProject()">
      <mat-icon aria-hidden="true">unarchive</mat-icon>
      Désarchiver le projet
    </button>
    }
  </div>
  <div class="tabs-container">
    @for (tab of tabs; track tab.id) {
    <button class="tab-btn" [class.active]="activeTab() === tab.id" (click)="setActiveTab(tab.id)">
      {{ tab.label }}
    </button>
    }
  </div>

  <div class="tab-content">
    @if (isLoading()) {
    <div class="loading-state"> Chargement... </div>
    } @else {
    @if (errorMessage()) {
    <div class="alert alert-error mb-4">{{ errorMessage() }}</div>
    }

    @if (project(); as p) {
    @switch (activeTab()) {
    @case ('details') {
    <app-project-details [project]="p" [isReadOnly]="isRestrictedRole()" (saved)="onProjectSaved()"
      (error)="onError($event)">
    </app-project-details>
    }
    @case ('document') {
    <app-project-documents [projectId]="p.id!" [isProjectLocked]="p.metaStatus !== 'DRAFT'"
      [readonlyMode]="isRestrictedRole()" (error)="onError($event)">
    </app-project-documents>
    }
    @case ('comptage') {
    <app-project-comptage [project]="p" [readonlyMode]="isRestrictedRole()" (saved)="onProjectSaved()"
      (error)="onError($event)">
    </app-project-comptage>
    }
    @case ('affaire') {
    <app-project-affaire [project]="p" [readonlyMode]="isRestrictedRole()" (saved)="onProjectUpdated($event)"
      (error)="onError($event)">
    </app-project-affaire>
    }
    @case ('sous-traitant') {
    <app-project-sous-traitant [project]="p" [readonlyMode]="isRestrictedRole()" (saved)="onProjectUpdated($event)"
      (error)="onError($event)">
    </app-project-sous-traitant>
    }
    @case ('fat') {
    <app-project-fat [projectId]="p.id!" [project]="p" (error)="onError($event)" (started)="onProjectSaved()">
    </app-project-fat>
    }
    @default {
    <app-project-tab-placeholder [label]="activeTab()"></app-project-tab-placeholder>
    }
    }
    }
    }
  </div>
</div>

@if (showArchiveDialog()) {
<app-confirm-dialog title="Archiver le projet"
  [message]="'Voulez-vous archiver le projet ' + (project()?.name || '') + ' ? Vous pourrez l\'afficher via le filtre des archivés.'"
  confirmLabel="Archiver"
  (confirmed)="confirmArchive()" (cancelled)="cancelArchive()">
</app-confirm-dialog>
}

@if (showUnarchiveDialog()) {
<app-confirm-dialog title="Désarchiver le projet"
  [message]="'Voulez-vous désarchiver le projet ' + (project()?.name || '') + ' ? Il réapparaîtra dans la liste par défaut.'"
  confirmLabel="Désarchiver"
  (confirmed)="confirmUnarchive()" (cancelled)="cancelUnarchive()">
</app-confirm-dialog>
}
